import { UserDto } from './user.dto';
import { IsNotEmpty, IsString, IsArray, IsNumber, IsOptional } from 'class-validator';

export class SalesDepartmentDto {
  id: number;
  title: string;
  employees: UserDto[];
  managerId: number;
  plan: number;
  planFulfillmentPercentage: number;
  planNonFulfillmentPercentage: number;
  manager: UserDto;
}
export class CreateSalesDepartmentDto {
  @IsString()
  @IsNotEmpty()
  title: string;

  @IsArray()
  employees: number[];

  @IsOptional()
  @IsNumber()
  managerId?: number;

  @IsOptional()
  @IsNumber()
  plan?: number;

  @IsOptional()
  @IsNumber()
  planFulfillmentPercentage?: number;

  @IsOptional()
  @IsNumber()
  planNonFulfillmentPercentage?: number;
}

export class UpdateSalesDepartmentDto {
  @IsNumber()
  id: number;

  @IsString()
  title: string;

  @IsArray()
  employees: number[];

  @IsOptional()
  @IsNumber()
  managerId?: number;

  @IsOptional()
  @IsNumber()
  plan?: number;

  @IsOptional()
  @IsNumber()
  planFulfillmentPercentage?: number;

  @IsOptional()
  @IsNumber()
  planNonFulfillmentPercentage?: number;
}
